import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { FormProvider } from './context/FormContext';
import Footer from './components/Footer';
import RequireAuth from './components/RequireAuth';
import Home from './pages/Home';
import LegalPage from './pages/LegalPage';
import ContactStep1 from './pages/ContactStep1';
import ComingSoon from './pages/ComingSoon';
import InvestorsLogin from './pages/InvestorsLogin';
import InvestorsPortal from './pages/InvestorsPortal';

// Routes that show the company footer
const FOOTER_ROUTES = ['/', '/coming-soon'];

function AppRoutes() {
  const { pathname } = useLocation();

  return (
    <div className="app-shell">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<LegalPage page="privacy" />} />
        <Route path="/terms" element={<LegalPage page="terms" />} />
        <Route path="/contact" element={<ContactStep1 />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/investor-login" element={<InvestorsLogin />} />
        <Route
          path="/investor-portal"
          element={
            <RequireAuth>
              <InvestorsPortal />
            </RequireAuth>
          }
        />
      </Routes>
      {FOOTER_ROUTES.includes(pathname) && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <FormProvider>
        <AppRoutes />
      </FormProvider>
    </Router>
  );
}

export default App;
